import React from 'react';
import {PcUserScale} from './pc/PcUserScale'; // 注意这里是默认导入
import {MobileUserScale} from './mobile/MobileUserScale'; // 注意这里是默认导入

function UserScale({isMobile, ...props}) { // 接收 isMobile props
    // 确保 clickNext 和 clickPrev props 被传递，如果未提供则使用空函数作为默认值
    const commonProps = {
        ...props,
        clickNext: props.clickNext || (() => {}),
        clickPrev: props.clickPrev || (() => {})
    };

    if (isMobile) { // 根据 isMobile props 条件渲染
        return <MobileUserScale {...commonProps} />;
    } else {
        return <PcUserScale {...commonProps} />;
    }
}

export default UserScale;